import React from "react"
import DataTable from "../DataTable/DataTable"

class DailyDashboard extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		return (
			<DataTable
        action_params={"currentDate=" + this.props.currentDate.toString('yyyy-MM-dd')}
        endpoint={this.dataTableEndpoint()}
        no_data_text={this.renderNoReservationsText()}
        export_csv_endpoint={'dashboard/export_csv.csv'}
        currency_unit={I18n.t('number.currency.format.unit')}
        delimiter={I18n.t('number.currency.format.delimiter')}
        separator={I18n.t('number.currency.format.separator')}
        date_format={this.props.dateFormat}
        time_format={this.props.timeFormat}
        show_trash={true} />
		);
	}

  renderNoReservationsText() {
    var hour = (new Date()).getHours();
    var day_night = 'day';

    if (hour > 4 && hour < 20) {
      day_night = 'day';
    } else {
      day_night = 'night';
    }

    return (
      <div className="welcome-no-reservations">
        <h1 className="text-center">{I18n.t('no_reservations_today')}</h1>
        <div className="welcome-day" style={{display: day_night == 'day' ? 'block' : 'none'}}></div>
        <div className="welcome-night" style={{display: day_night == 'night' ? 'block' : 'none'}}></div>
      </div>
    );
  }

  dataTableEndpoint() {
    var endpoint = this.props.path.substring(0, this.props.path.lastIndexOf('/'));
    return endpoint + '/' + this.props.currentDate.toString('yyyy-MM-dd');
  }

}

export default DailyDashboard
